// DemoApp.js - Entry point for NeuroNest demo
import React from 'react';
import DemoHeader from './Header';
import MoodCheckIn from './MoodCheckIn';
import TaskList from './TaskList';
import NotificationSettings from './NotificationSettings';
import PhotoTaskInput from './PhotoTaskInput';
import CapacityEvaluator from './CapacityEvaluator';
import TaskTimer from './TaskTimer';

const DemoApp = () => (
    <div className="app-container">
        <DemoHeader />
        <MoodCheckIn />
        <TaskList />
        <NotificationSettings />
        <PhotoTaskInput />
        <CapacityEvaluator />
        <TaskTimer />
    </div>
);

export default DemoApp;